import React, { useEffect, useState, useContext } from "react";
import { Paper, Box, Grid, Avatar, Chip, Switch, FormControlLabel, Typography, InputAdornment, CircularProgress, MenuItem, TextField, IconButton } from '@mui/material';
import { DndContext, closestCenter, DragOverlay, PointerSensor, useSensor, useSensors, } from "@dnd-kit/core";
import { SortableContext, arrayMove } from "@dnd-kit/sortable";
import { SortableItem, DroppableColumn } from "./TicketData";
import SearchIcon from "@mui/icons-material/Search";
import { DataGrid } from '@mui/x-data-grid';
import Pagination from '@mui/material/Pagination';
import ApiService from '../../functions/apiService';
import { toast } from 'react-toastify';
import moment from "moment";
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import AuthContext from "../../context/AuthContext";
import TicketModal from "./TicketModal";
import CreateTicket from "./CreateTicketModal";
import Modal from 'react-bootstrap/Modal';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import CalendarTodayOutlinedIcon from '@mui/icons-material/CalendarTodayOutlined';
import LocationOnOutlinedIcon from '@mui/icons-material/LocationOnOutlined';
import PersonOutlineIcon from '@mui/icons-material/PersonOutline';
import { Row , Col } from "react-bootstrap";

const transformData = (apiData) => {
  const statusMap = {
    todo: "todo",
    progress: "progress",
    // review: "review",
    completed: "completed",
    cancelled: "cancelled"
  };

  const columns = {
    todo: { name: "To Do", items: [] },
    progress: { name: "Progress", items: [] },
    // review: { name: "Review", items: [] },
    completed: { name: "Completed", items: [] },
    cancelled: { name: "Cancelled", items: [] }
  };

  apiData.map((ticket) => {
    const statusKey = statusMap[ticket.tickteting_status?.status] || "todo";

    if (columns[statusKey]) {
      columns[statusKey].items.push({
        id: String(ticket.id),
        content: ticket.title,
        description: ticket.description,
        employee_first_name: ticket.employee_first_name,
        employee_last_name: ticket.employee_last_name,
        date: ticket.updated_at,
        image: ticket.image,
				employee_code: ticket.employee_code,
				secondaryImage : ticket.secondary_image,
				Assigned_by : ticket.assignee,
				ticket_type : ticket?.ticket_type,
				checklist_item : ticket.checklist_item,
				location_name : ticket.location_name,
				item_name : ticket.item_name,
				location_path : ticket.location_path
      });
    }
  });

  return columns;
};

const Ticketing = () => {
	const { user } = useContext(AuthContext);
  const [activeItem, setActiveItem] = useState(null);
  const [viewType, setViewType] = useState("card");
  const [currentPage, setCurrentPage] = useState(1);
  const [filter, setfilter] = useState(1);
  const [data, setdata] = useState([]);
  const [ticketType, setTicketType] = useState('myTicket');
  const [myCount, setMyCount] = useState('');
  const [allCount, setAllCount] = useState('');
	const [show, setShow] = useState(false);
	const [ticketData, setTicketData] = useState('')
	const [addModal, setAddModal] = useState(false);
  const ITEMS_PER_PAGE = 10;
  const limit = 50;
  const titleLimit = 23;

  const [searchQuery, setSearchQuery] = useState('');

  const [columns, setColumns] = useState({
    todo: { name: "To Do", items: [] },
    inProgress: { name: "Progress", items: [] },
    // review: { name: "Review", items: [] },
    completed: { name: "Completed", items: [] },
    cancelled: { name: "Cancelled", items: [] }
  });

  const statusChipStyle = (statusId) => {
    const map = {
      1: { background: '#FFF3CD', color: '#856404', label: 'To Do' },
      2: { background: '#CCE5FF', color: '#004085', label: 'In Progress' },
      4: { background: '#D4EDDA', color: '#155724', label: 'Completed' },
      5: { background: '#F8D7DA', color: '#721C24', label: 'Cancelled' },
    };
    return map[statusId] || { background: '#E2E3E5', color: '#383D41', label: 'N/A' };
  };

  const columnsTable = [
    {
      field: 'updated_at',
      headerName: 'Date',
      width: 150,
      renderCell: (params) =>
        <span style={{ fontSize: '13px' }}>{moment(params.row.updated_at).format('MM/DD/YYYY')}</span>
    },
    {
      field: 'title',
      headerName: 'Title',
      width: 220,
      renderCell: (params) => (
        <div style={{ fontWeight: 600, fontSize: '13px', whiteSpace: 'normal', lineHeight: '1.4' }}>
          {params.value || '—'}
        </div>
      ),
    },
    {
      field: 'employee_full_name',
      headerName: 'Assigned to',
      width: 200,
      valueGetter: (params) => {
        const fn = params?.row?.employee_first_name || '';
        const ln = params?.row?.employee_last_name || '';
        return fn || ln ? `${fn} ${ln}`.trim() : '—';
      },
    },
    {
      field: 'description',
      headerName: 'Description',
      width: 280,
      renderCell: (params) => (
        <div style={{ whiteSpace: 'normal', wordWrap: 'break-word', lineHeight: '1.4', fontSize: '13px' }}>
          {params.value || '—'}
        </div>
      ),
    },
    {
      field: 'status',
      headerName: 'Status',
      sortable: true,
      width: 140,
      renderCell: (params) => {
        const statusId = params.row.tickteting_status?.id;
        const chip = statusChipStyle(statusId);
        return (
          <span style={{
            background: chip.background,
            color: chip.color,
            borderRadius: '12px',
            padding: '3px 10px',
            fontSize: '12px',
            fontWeight: 600,
          }}>
            {chip.label}
          </span>
        );
      },
    },
    {
      field: 'image',
      headerName: 'Image',
      sortable: false,
      width: 80,
      renderCell: (params) => params.value ? (
        <a href={params.value} target="_blank" rel="noopener noreferrer">
          <img src={params.value} alt="img" style={{ width: '36px', height: '36px', objectFit: 'cover', borderRadius: '50%', border: '1px solid #ddd' }} />
        </a>
      ) : <span style={{ color: '#aaa', fontSize: '12px' }}>—</span>,
    },
    {
      field: 'actions',
      headerName: 'Actions',
      sortable: false,
      width: 90,
      renderCell: (params) => (
        <IconButton size="small" sx={{ color: '#BF1D2D' }} onClick={() => { setTicketData(params?.row); setShow(true); }}>
          <VisibilityOutlinedIcon fontSize="small" />
        </IconButton>
      ),
    }
  ];

  const sensors = useSensors(
    useSensor(PointerSensor, {
      activationConstraint: {
        distance: 10,
      },
    })
  );

  const TicketData = () => {
    const body = {
      "type" : ticketType
    }
    ApiService.post('/tickets/checklists/show-ticket', body)
		.then((data) => {
			setMyCount(data?.data?.counts?.my_ticket_count)
			setAllCount(data?.data?.counts?.all_ticket_count)
      const transformedColumns = transformData(data.data?.tickets);
      setColumns(transformedColumns);
      setdata(data.data?.tickets)
    }).catch((error) => {
			console.error("error", error)
      toast.error(error);
    })
  };

  useEffect(() => {
    TicketData()
  }, [ticketType])

  const onDragStart = (event) => {
    const { active } = event;
    if (active) {
      const item = Object.values(columns)
        .flatMap((col) => col.items)
        .find((item) => item.id === active.id);
      setActiveItem(item);
    }
  };

  const statusMapping = {
    todo: 1,
    progress: 2,
    // review: 3,
    completed: 4,
    cancelled: 5
  };

  const onDragEnd = (event) => {
    const { active, over } = event;
    setActiveItem(null);

    if (!over) return;

    const sourceColId = Object.keys(columns).find((key) =>
      columns[key].items.some((item) => item.id === active.id)
    );

    if (!sourceColId) return;

    let destColId =
      Object.keys(columns).find((key) =>
        columns[key].items.some((item) => item.id === over.id)
      ) || over.id;

    if (!columns[destColId]) return;

    const newStatus = statusMapping[destColId];

    if (newStatus === undefined) {
      console.error("Invalid destination column ID:", destColId);
      return;
    }

    if (sourceColId === destColId) {
      const newItems = arrayMove(
        columns[sourceColId].items,
        columns[sourceColId].items.findIndex((item) => item.id === active.id),
        columns[sourceColId].items.findIndex((item) => item.id === over.id)
      );

      setColumns((prev) => ({
        ...prev,
        [sourceColId]: { ...prev[sourceColId], items: newItems },
      }));
    } else {
      const sourceItems = [...columns[sourceColId].items];
      const destItems = [...columns[destColId].items];
      const [movedItem] = sourceItems.splice(
        sourceItems.findIndex((item) => item.id === active.id),
        1
      );

      destItems.push(movedItem);

      setColumns((prev) => ({
        ...prev,
        [sourceColId]: { ...prev[sourceColId], items: sourceItems },
        [destColId]: { ...prev[destColId], items: destItems },
      }));

      handleTicketStatus(active.id, newStatus);
    }
  };

  const handleTicketStatus = (ticketId, newStatus) => {
    const body = {
      checklist_ticket_id: ticketId,
      status: newStatus,
    };

    ApiService.post('/tickets/checklists/update-status', body)
      .then((response) => {
        toast.success(response.message);
        // const transformedColumns = transformData(response.data);
        // setColumns(transformedColumns);
      })
      .catch((error) => {
        toast.error(error?.data?.message);
				setTimeout(()=> window?.location?.reload(), 3000)
      });
  };

  const filteredData = searchQuery.trim()
    ? data.filter(ticket => ticket.title?.toLowerCase().includes(searchQuery.toLowerCase()))
    : data;

  const filteredColumns = searchQuery.trim()
    ? Object.fromEntries(
        Object.entries(columns).map(([key, col]) => [
          key,
          { ...col, items: col.items.filter(item => item.content?.toLowerCase().includes(searchQuery.toLowerCase())) }
        ])
      )
    : columns;

  const paginatedData = filteredData.slice((currentPage - 1) * ITEMS_PER_PAGE, currentPage * ITEMS_PER_PAGE);
  const totalPages = Math.ceil(filteredData.length / ITEMS_PER_PAGE);


  return (
		<>
    <Paper className="p-4 font-fam" style={{ marginTop: "1rem", padding: "1rem" }}>
      <Grid container className='align-items-center' gap={2} style={{ gap: "24px", marginTop: "7px", marginBottom: '30px' }} >
        <Grid item xs={12} md={2}>
          <Typography variant="h5">Ticketing</Typography>
        </Grid>

				<Grid container item md={4} gap={1}>
        <Grid item xs={6} sm={12} md={5}>
				<div 
				className={ticketType == 'myTicket' ? 'tab-active' : 'tab-white'}
					style={{
						width: '150px'
					}}
					onClick={() => {
						setTicketType('myTicket')
					}}>
					{`My Tickets (${myCount || 0})`}
					{/* {'My Tickets'} */}
				</div>
				</Grid>

        <Grid item xs={6} sm={12} md={5}>
				<div 
				className={ticketType == 'allTicket' ? 'tab-active' : 'tab-white'}
					style={{
						width: '150px'
					}}
					onClick={() => {
						setTicketType('allTicket')
					}}>
					{`All Tickets (${allCount || 0})`}
					{/* {'All Tickets'} */}
				</div>
				</Grid>
				</Grid>

        <Grid item xs={6} sm={12} md={1}>
          <div
            style={{
              height: "48px",
              border: "1px solid #EAECF0",
              borderRadius: "8px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                width: "48px",
                height: "48px",
                cursor: "pointer",
                borderRight: "1px solid #EAECF0",
              }}
              onClick={() => setViewType("card")}
            >
              <img
                src={viewType === "list" ? "/images/card-empty.svg" : "/images/card.svg"}
                height="22px"
                width="22px"
              />
            </div>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                width: "48px",
                height: "48px",
                cursor: "pointer",
              }}
              onClick={() => setViewType("list")}
            >
              <img
                src={viewType === "list" ? "/images/listview.svg" : "/images/list-empty.svg"}
                height="20px"
                width="20px"
              />
            </div>
          </div>
        </Grid>

        <Grid item>
          <button
            className="btn"
            style={{ backgroundColor: '#BF1D2D', color: '#fff', height: '48px', borderRadius: '8px', padding: '0 16px', whiteSpace: 'nowrap' }}
            onClick={() => setAddModal(true)}
          >
            + Create Ticket
          </button>
        </Grid>

        <Grid item xs={12} sm={12} md={2}>
          <TextField
            variant="outlined"
            placeholder="Search by title"
            className="w-100"
            value={searchQuery}
            onChange={(e) => { setSearchQuery(e.target.value); setCurrentPage(1); }}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <SearchIcon sx={{ color: '#aaa' }} />
                </InputAdornment>
              ),
              sx: {
                height: '48px',
                fontSize: '14px',
              },
            }}
          />
        </Grid>
      </Grid>

      {viewType == 'card' &&
        <DndContext
          collisionDetection={closestCenter}
          onDragStart={onDragStart}
          onDragEnd={onDragEnd}
          sensors={sensors}
        >

          <div style={{ overflowX: 'auto', whiteSpace: 'nowrap', scrollbarWidth: 'none' }}>
            <Grid container spacing={2} wrap="nowrap">
              {Object.entries(filteredColumns).map(([columnId, column]) => (
                <Grid item xs={4} key={columnId} style={{ minWidth: '300px' }}>
                  <DroppableColumn columnId={columnId} column={column}>
                    <SortableContext items={column.items.map((item) => item.id)}>
                      {column.items.map((item) => (
                        <SortableItem 
													key={item.id} 
													item={item} 
													activeItem={activeItem} 
													ticketApi={TicketData} 
													ticketType={ticketType} 
                          TicketData={TicketData}
												/>
                      ))}
                    </SortableContext>
                  </DroppableColumn>
                </Grid>
              ))}
            </Grid>
          </div>


          <DragOverlay>
            {activeItem ? (() => {
              const dragAssigneeName = `${activeItem?.employee_first_name || ''} ${activeItem?.employee_last_name || ''}`.trim();
              const dragInitials = dragAssigneeName
                ? dragAssigneeName.split(' ').map(n => n[0]).slice(0, 2).join('').toUpperCase()
                : '?';
              const dragLocationLabel = activeItem?.ticket_type === 'location' || activeItem?.ticket_type === 'location_item' || activeItem?.checklist_item?.location ? 'Location' : 'Item';
              const dragLocationValue = activeItem?.checklist_item?.item_location?.item?.item_description
                || activeItem?.checklist_item?.location?.location_description
                || activeItem?.location_name
                || activeItem?.item_name
                || 'General Ticket';

              return (
                <Box sx={{
                  backgroundColor: 'white',
                  borderRadius: '12px',
                  overflow: 'hidden',
                  boxShadow: '0px 8px 24px rgba(0,0,0,0.18)',
                  border: '1px solid #F0F0F0',
                  maxWidth: '300px',
                  cursor: 'grabbing',
                  opacity: 0.96,
                }}>
                  {/* Header */}
                  <Box sx={{ px: 2, pt: 1.5, pb: 1 }}>
                    <Box sx={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', gap: 1 }}>
                      <Typography fontWeight={700} fontSize="14px" sx={{
                        flex: 1, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', color: '#1A1A2E',
                      }}>
                        {activeItem?.content || 'No Title'}
                      </Typography>
                      <span style={{ fontSize: '13px', color: '#D92D20', fontWeight: 600, whiteSpace: 'nowrap', flexShrink: 0 }}>
                        Details →
                      </span>
                    </Box>
                    {activeItem?.employee_code == user?.Emp_Code && ticketType === 'allTicket' && (
                      <Box sx={{ mt: 0.5 }}>
                        <span style={{ background: '#ECFDF3', color: '#027A48', fontSize: '11px', fontWeight: 600, borderRadius: '20px', padding: '2px 10px', border: '1px solid #A9EFC5' }}>
                          My Ticket
                        </span>
                      </Box>
                    )}
                  </Box>

                  <Box sx={{ height: '1px', backgroundColor: '#F0F0F0' }} />

                  {/* Body */}
                  <Box sx={{ px: 2, py: 1.5 }}>
                    {activeItem?.description && (
                      <Typography sx={{ fontSize: '13px', color: '#667085', mb: 1.5, lineHeight: 1.5 }}>
                        {activeItem.description.substring(0, limit)}{activeItem.description.length > limit ? '…' : ''}
                      </Typography>
                    )}

                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 0.75 }}>
                      <PersonOutlineIcon sx={{ fontSize: '15px', color: '#98A2B3' }} />
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75, minWidth: 0 }}>
                        <Box sx={{ width: 22, height: 22, borderRadius: '50%', background: '#BF1D2D', color: '#fff', fontSize: '10px', fontWeight: 700, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                          {dragInitials}
                        </Box>
                        <Typography sx={{ fontSize: '13px', color: '#344054', fontWeight: 500, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                          {dragAssigneeName || '—'}
                        </Typography>
                      </Box>
                    </Box>

                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 0.75 }}>
                      <CalendarTodayOutlinedIcon sx={{ fontSize: '15px', color: '#98A2B3' }} />
                      <Typography sx={{ fontSize: '13px', color: '#344054' }}>
                        {moment(activeItem.date).format('MM/DD/YYYY')}
                      </Typography>
                    </Box>

                    <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1, mb: 0.5 }}>
                      <LocationOnOutlinedIcon sx={{ fontSize: '15px', color: '#98A2B3', mt: '1px' }} />
                      <Typography sx={{ fontSize: '13px', color: '#344054', lineHeight: 1.4 }}>
                        <span style={{ color: '#667085', fontWeight: 500 }}>{dragLocationLabel}: </span>
                        {dragLocationValue}
                      </Typography>
                    </Box>

                    {activeItem?.location_path?.length > 0 && (
                      <Box sx={{ display: 'flex', flexWrap: 'nowrap', gap: '4px', mt: 0.75, overflowX: 'auto', scrollbarWidth: 'none' }}>
                        {activeItem.location_path.map((loc, index) => (
                          <span key={index} style={{ fontSize: '11px', background: '#F2F4F7', color: '#344054', borderRadius: '20px', padding: '2px 10px', border: '1px solid #D0D5DD', whiteSpace: 'nowrap', fontWeight: 500 }}>
                            {loc}
                          </span>
                        ))}
                      </Box>
                    )}
                  </Box>

                  {/* Footer */}
                  <Box sx={{ height: '1px', backgroundColor: '#F0F0F0' }} />
                  <Box sx={{ px: 2, py: 1, display: 'flex', alignItems: 'center', justifyContent: 'space-between', background: '#FAFAFA' }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                      <IconButton size="small" sx={{ color: '#98A2B3' }}>
                        <EditIcon sx={{ fontSize: '17px' }} />
                      </IconButton>
                      <IconButton size="small" sx={{ color: '#98A2B3' }}>
                        <DeleteIcon sx={{ fontSize: '17px' }} />
                      </IconButton>
                    </Box>
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                      {activeItem.image && (
                        <img src={activeItem.image} height="28px" width="28px"
                          style={{ borderRadius: '50%', border: '2px solid #fff', boxShadow: '0 0 0 1px #D0D5DD', objectFit: 'cover' }} />
                      )}
                      {activeItem.secondaryImage && (
                        <img src={activeItem.secondaryImage} height="28px" width="28px"
                          style={{ borderRadius: '50%', border: '2px solid #fff', boxShadow: '0 0 0 1px #D0D5DD', objectFit: 'cover', marginLeft: '-8px' }} />
                      )}
                    </Box>
                  </Box>
                </Box>
              );
            })() : null}
          </DragOverlay>
        </DndContext>
      }

      {viewType == 'list' &&
        <>
          {paginatedData.length === 0 &&
						<div className='d-flex flex-column align-items-center justify-content-center' style={{ height: 495, width: "100%" }}>
								<img src='/images/blur-logo.png' style={{ height: 200, width: 250 }} />
								<span className='mt-4' style={{ color: '#555555' }}>
									No Tickets Found
								</span>
							</div>
          }
          {paginatedData.length > 0 &&
            <Box sx={{ width: '100%' }}>
              <DataGrid
                rows={paginatedData}
                columns={columnsTable}
                getRowHeight={() => 72}
                hideFooter
                disableRowSelectionOnClick
                sx={{
                  '& .MuiDataGrid-row': {
                    borderBottom: 'none',
                  },
                }}
              />
            </Box>
          }

          <Pagination
            count={totalPages}
            color="primary"
            className="mt-3 mb-3 d-flex"
            style={{ justifyContent: 'end' }}
            page={currentPage}
            onChange={(event, page) => setCurrentPage(page)}
          />
        </>
      }
    </Paper>

		<CreateTicket
		addModal={addModal}
		setAddModal={setAddModal}
		ticketType=""
		ticketLocId=""
		ticketLocName=""
		itemLocId=""
		itemLocName=""
	/>

	<Modal show={show} onHide={() => {
			setShow(false)
			TicketData()
			}} size='xl'>
				<Modal.Body className='p-0'>
					<TicketModal
						show={show}
						setShow={setShow}
						item={ticketData}
						ticketApi={TicketData}
					/>
				</Modal.Body>
			</Modal>
		</>
  );
};

export default Ticketing;

